export const PHONE_LENGTH = 10;

/** Digits only, max 10 — use on change for phone/contact fields. */
export const sanitizePhoneInput = (value) =>
  String(value ?? "").replace(/\D/g, "").slice(0, PHONE_LENGTH);

export const phoneTextFieldInputProps = {
  maxLength: PHONE_LENGTH,
  inputMode: "numeric",
  pattern: "[0-9]*",
};

export const isValidPhone = (value) =>
  new RegExp(`^\\d{${PHONE_LENGTH}}$`).test(String(value ?? "").trim());

/** Optional phone: empty or exactly 10 digits. */
export const isEmptyOrValidPhone = (value) => {
  const v = String(value ?? "").trim();
  return v === "" || isValidPhone(v);
};
